import React from 'react';
import SectionShell from '../SectionShell';
import Reveal from '../Reveal';
import CountUp from '../CountUp';
import { useT } from '../../i18n/LanguageContext';

/**
 * Folie 29 — Unilevel Bonus.
 * 3 stacked luxury level cards with the original PPTX coin badges (Partner /
 * Pearl / Ruby, image84 / 83 / 85). Same visual language as the Bonusarten
 * cards on Folie 28 — gold gradient outer frame + dark inner + gold accent.
 */
export default function SectionUnilevelBonus() {
  const { t } = useT();
  const m = t.unilevel;

  return (
    <SectionShell id="unilevel-bonus" className="">
      <div className="grid grid-cols-12 gap-y-10 md:gap-12 mb-14 items-end">
        <div className="col-span-12 md:col-span-5">
          <Reveal>
            <div className="overline mb-6">{m.overline}</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-white max-w-[16ch]">
              {m.title}
            </h2>
          </Reveal>
        </div>
        <div className="col-span-12 md:col-span-7">
          <Reveal delay={120}>
            <p className="font-ui text-2xl lg:text-3xl text-white/75 leading-relaxed">
              {m.sub}
            </p>
          </Reveal>
        </div>
      </div>

      <div>
      <div className="space-y-5 w-full max-w-[1400px] mx-auto" data-testid="unilevel-list">
        {m.levels.map((lvl, i) => (
          <Reveal key={i} delay={100 + i * 120}>
            <div data-testid={`unilevel-${i + 1}`} className="unilevel-card group">
              <div className="unilevel-card-inner">
                {/* LEFT — coin badge */}
                <div className="unilevel-coin">
                  <img
                    src={`/source-pptx/${lvl.coin}`}
                    alt={`${lvl.badge} Badge`}
                    loading="lazy"
                    draggable={false}
                    className="block w-full h-full object-contain select-none"
                    style={{ filter: 'drop-shadow(0 12px 22px rgba(0,0,0,0.6))' }}
                  />
                </div>

                {/* MIDDLE — level label + qualification */}
                <div className="flex-1 min-w-0">
                  <div className="font-display text-3xl md:text-4xl text-white uppercase tracking-wide leading-tight">
                    {lvl.level}
                  </div>
                  <div className="font-ui text-xl md:text-2xl text-white/70 mt-3 leading-snug">
                    {lvl.qual}
                  </div>
                </div>

                {/* RIGHT — big gold percentage */}
                <div className="unilevel-value font-display">{lvl.value}</div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      {/* Total summary strip */}
      <Reveal delay={520}>
        <div className="unilevel-total mt-8" data-testid="unilevel-total">
          <span className="unilevel-total-line" aria-hidden />
          <div className="unilevel-total-block">
            <span className="unilevel-total-big font-display">{(m.totalParts?.prefix || 'Bis zu')} </span>
            <span className="unilevel-total-huge font-display"><CountUp value={m.totalParts?.big || '18%'} /></span>
            <span className="unilevel-total-big font-display"> {m.totalParts?.suffix || 'Unilevel Bonus'}</span>
          </div>
          <span className="unilevel-total-line" aria-hidden />
        </div>
      </Reveal>
      </div>
    </SectionShell>
  );
}
